import { Base } from '@studiometa/js-toolkit';
import Collapse from '../molecules/Collapse/index.js';
import LessonPanel from '../molecules/LessonPanel.js';
import PanelBtn from '../atoms/PanelBtn.js';

/**
 * Lesson component
 */
export default class Elearning extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Elearning',
    components: {
      LessonPanel,
      Collapse,
      PanelBtn,
    },
  };

  /**
   * Open Panel
   * @param {number} index
   * @param {chapter} chapter
   */
  onPanelBtnOpen(index, chapter) {
    this.$children.LessonPanel[index].open();
    this.$children.LessonPanel[index].$children.Collapse[0].$children.CollapseItem.forEach(
      (element) => {
        element.close();
      },
    );
    this.$children.LessonPanel[index].$children.Collapse[0].$children.CollapseItem[chapter].open();
  }
}
